import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'

const progressBarOptions = {
  color: '#009688',
  failedColor: '#ff6347',
  thickness: '2px'
}

Vue.use(VueProgressBar, progressBarOptions)
